/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemReEnterSetting } from './formPagePropertyItemReEnterSetting';
import { FormPagePropertyItemMailAddressErrorMessage } from './formPagePropertyItemMailAddressErrorMessage';
import { FormPagePropertyItemMailAddressInputFormat } from './formPagePropertyItemMailAddressInputFormat';
import { FormPagePropertyItemMailAddressAllOf } from './formPagePropertyItemMailAddressAllOf';
import { FormPagePropertyItemStringConvertRule } from './formPagePropertyItemStringConvertRule';


/**
 * メールアドレス型の入力項目を表す。 メールアドレス型のバリデーションは、必須入力、メールアドレス形式であるかどうかの2点。 ドメインを選択肢から選択する入力形式の場合に、選択肢外のドメインを選択されてもエラーにはしていない。 なので、単純にローカルパートとドメイン部分を@で結合して形式チェックする感じでよさそう。 Newtフォームでのメールアドレス形式チェックは、DBAPIのバリデーションに倣う想定。 http://gitlab.dev-internal.crmstyle.com/synergy/typhoon/db/dbapi/-/blob/master/api-server/src/main/kotlin/v1/apis/JsonSchemas.kt#L59 
 */
export interface FormPagePropertyItemMailAddress { 
    /**
    * フォーム入力項目大種別
    */
    propertyType: 'mailAddress';
    /**
    * 入力項目ID
    */
    propertyId: string;
    /**
    * 項目名(管理機能のopenapiではdisplay_name）
    */
    name: string;
    /**
    * 項目のコメント(管理機能のopenapiではdisplay_comment）
    */
    comment?: string;
    /**
    * 注意書き・凡例(管理機能のopenapiではcaution）
    */
    note?: string;
    /**
    * 必須/任意のラベルを表示するかどうか.
    */
    displayRequiredLabel: boolean;
    stringConvertRule?: FormPagePropertyItemStringConvertRule;
    type: FormPagePropertyItemMailAddress.TypeEnum;
    format: FormPagePropertyItemMailAddress.FormatEnum;
    /**
    * 入力可能な最大文字数。固定で4000文字。
    */
    maxLength: number;
    reEnter?: FormPagePropertyItemReEnterSetting;
    inputFormat: FormPagePropertyItemMailAddressInputFormat;
    errorMessage?: FormPagePropertyItemMailAddressErrorMessage;
}

export namespace FormPagePropertyItemMailAddress {
    export type TypeEnum = 'string';
    export const TypeEnum = {
        String: 'string' as TypeEnum
    };
    export type FormatEnum = 'email';
    export const FormatEnum = {
        Email: 'email' as FormatEnum
    };
}


